import { h, Component } from 'preact';
import Spinner from '../component/Spinner';
import constants from '../constants';
import designService from "../service/designService";
import categoryService from "../service/categoryService";
import searchService from "../service/searchService";
import designDomain from "../domain/designDomain";
import util from "../util";
import Masonry from 'react-masonry-component';
import UseTemplateModal from "./UseTemplateModal";
import FreeProFlag from './FreeProFlag';
import store from "../store";
import * as actions from "../actions";
import { initDesignInStore } from "../service/storeService";
import { renderDesign } from "../canvas/renderer";
import TemplateCard from './card/TemplateCard';
import menuObject from '../canvas/menu-object';

export default class AsideTemplates extends Component {
  constructor() {
    super();
    this.state = {
      searchBy: '',
      page: 0,
      pageSize: constants.INFINITE_LOAD_PAGE_SIZE,
      isSearching: false,
      isLoadingTemplates: false,
      useDesign: null,
      useDesignModal: false,
      sets: [],
      isCurrentSetLoading: false,
      currentSet: null,
      siblingSet: null,
      isSetsView: false,
      isSearchView: false,
      selectedSize: '',
      selectedColors: [],
      numberOfAppliedFilters: 0,
      category: '',
      categories: [],
      suggestedCategories: [],
      templatesCountBySize: []
    };

    this.useTemplate = (design) => {
      if (!this.props.isTemplate && this.props.hasChanges) {
        this.setState({
          useDesign: design,
          useDesignModal: true
        });
      } else if (!this.props.hasChanges) {
        this.updateTemplate(design);
      }
    };

    this.toggleSetsView = () => {
      this.setState({
        isSetsView: !this.state.isSetsView
      })
    };

    this.filterSuggestedCategories = (value) => {
      if (!value) this.setState({ suggestedCategories: [], searchBy: value });
      else {
        const suggestedCats = this.state.categories.filter((category) =>
          category.name.toLowerCase().includes(value.toLowerCase())
        );

        $('.suggested-categories').show();
        this.setState({ suggestedCategories: suggestedCats, searchBy: value });
      }
    }

    this.onChangeSearchField = (ev) => {
      this.setState({
        page: 0,
        searchBy: ev.target.value,
        suggestedCategories: []
      });

      store.dispatch(actions.setSelectedCategory(''));

      // if (ev.target.value.trim().length === 0) {
      store.dispatch(actions.setTemplateView('group'));
      this.setState({ isSearchView: false });
      // }

      if (!this.state.isSearching) {
        this.trackSearch();
        this.setState({ isSearching: true, isSearchView: true });
        this.fetchTemplates($('.search-templates').val(), this.props.selectedFamily || '');
      }
    };

    this.onClickDeleteInputSearch = () => {
      this.setState({
        page: 0,
        searchBy: '',
      });

      store.dispatch(actions.setSelectedCollection(''));

      if (this.props.selectedCategory) {
        store.dispatch(actions.setSelectedCategory(''));
        this.selectFamily('Menu');
        return;
      }

      $('#delete-icon').hide();

      if (this.props.selectedFamily) {
        store.dispatch(actions.setTemplateView('group'));
      } else {
        store.dispatch(actions.setTemplateView('families'));
      }

      this.setState(() => ({ isLoadingTemplates: true }));

      if (!this.state.isSearching) {
        this.trackSearch();

        this.setState({ isSearching: true });
        this.fetchTemplates(null, this.props.selectedFamily);
      }

      this.setState({ isSearchView: false });
    };

    this.trackSearch = () => {
      try {
        ga('send', 'pageview', '?q=' + this.state.searchBy);
      } catch (e) {
        console.log('> Was not possible to track search. Possibly because of a tracking blocker on the browser.');
        console.log(e);
      }
    };

    this.infiniteLoadTemplates = () => {
      if (this.state.isSetsView) return;

      const $scroller = $('#app-aside .scroller');
      let top = $scroller.scrollTop();

      if (top >= $(".designs").height() - $scroller.height() - 100) {
        if (!this.state.isLoadingTemplates && !store.getState().promoDesignsLoading) {
          this.setState(() => ({
            isLoadingTemplates: true,
            page: this.state.page + 1
          }));

          util.nextTick(() => {
            if (this.props.selectedFamily || this.props.selectedCategory || this.props.selectedCollection) {
              designService.getTemplatesByStatusAndSizeGrouped(
                this.props.selectedFamily, this.state.page, this.state.pageSize, this.state.searchBy, this.state.selectedSize,
                (this.state.selectedColors && this.state.selectedColors.length > 0) ? this.state.selectedColors.join(',') : '')
                .then(response => {
                  const page = response.data[0].designs.map(design => new designDomain.Design(design, util.sizes));
                  let existing = this.props.templateGroups.find(it => !it.collection);

                  existing.designs = [...existing.designs, ...page];
                  store.dispatch(actions.setTemplateGroups([...this.props.templateGroups]));
                  this.setState({ isLoadingTemplates: false });
                }).catch(() => {
                  store.dispatch(actions.setTemplateGroups([], false));
                  this.setState({ isLoadingTemplates: false });
                });
            } else {
              searchService.getTemplates(this.state.searchBy, this.state.page, this.state.pageSize).then((resp) => {
                const page = resp.data.templates.map(template => new designDomain.Design(template, util.sizes));
                let existing = this.props.templateGroups.find(it => !it.collection);

                existing.designs = [...existing.designs, ...page];
                store.dispatch(actions.setTemplateGroups([...this.props.templateGroups]));
                this.setState({ isLoadingTemplates: false });
              });
            }
          });
        }
      }
    };

    this.fetchTemplates = (searchBy, size, categoryId = '') => {
      const state = this.state;

      if (!searchBy) {
        this.setState({ isSearchView: false });
      }

      store.dispatch(actions.setTemplateGroups([], true));

      if (this.props.selectedFamily || this.props.selectedCategory || this.props.selectedCollection || !searchBy) {
        const colors = (this.state.selectedColors && this.state.selectedColors.length > 0) ? this.state.selectedColors.join(',') : '';

        designService.getTemplatesByStatusAndSizeGrouped(size,
          0,
          state.pageSize,
          searchBy,
          this.state.selectedSize,
          colors,
          categoryId,
        ).then(response => {
          store.dispatch(actions.setTemplateGroups(response.data, false));
          this.setState({ isSearching: false });
        }).catch(() => {
          store.dispatch(actions.setTemplateGroups([], false));
        })
      } else {
        searchService.getTemplates(searchBy).then((resp) => {
          store.dispatch(actions.setTemplateGroups([{ designs: resp.data.templates }], false));
          this.setState({ isSearching: false });
        });
      }
    };

    this.selectCollection = this.selectCollection.bind(this);
  }

  //   this.fetchTemplates = (searchBy, size, categoryId = '') => {
  //     const state = this.state;

  //     if (!searchBy) {
  //       this.setState({ isSearchView: false });
  //     }

  //     store.dispatch(actions.setTemplateGroups([], true));

  //     const colors = (this.state.selectedColors && this.state.selectedColors.length > 0) ? this.state.selectedColors.join(',') : '';

  //     designService.getTemplatesByStatusAndSizeGrouped(size,
  //       0,
  //       state.pageSize,
  //       searchBy,
  //       this.state.selectedSize,
  //       colors,
  //       categoryId,
  //     ).then(response => {
  //       store.dispatch(actions.setTemplateGroups(response.data, false));
  //       this.setState({ isSearching: false });
  //     }).catch(() => {
  //       store.dispatch(actions.setTemplateGroups([], false));
  //     })
  //   };

  //   this.selectCollection = this.selectCollection.bind(this);
  // }

  componentDidMount() {
    if (this.props.isQRDesignMode) {
      this.fetchTemplates('qr', store.getState().selectedFamily);
      this.setState({ page: 0, searchBy: 'QR' });
    } else {
      if (this.props.templateId) {
        this.fetchTemplateSets();
      }
      this.setState({ page: 0, searchBy: '' });
      $('#delete-icon').hide();
    }

    if (!this.state.categories.length) {
      const categoriesToFilterOut = [7258, 8618, 8619, 8620, 8621, 8622, 8623, 8624, 8625, 8626, 8627, 8647, 8752, 8755, 8762];

      categoryService.findAllCategories().then(it => {
        const filtered = it.data.filter((category) =>
          !categoriesToFilterOut.includes(category.id)
        );
        this.setState({ categories: filtered });
      });
    }

    if (!this.state.templatesCountBySize.length) {
      designService.getTemplatesCountBySize().then(it => {
        this.setState({ templatesCountBySize: it.data })
      });
    }
  }

  componentDidUpdate(previousProps, previousState, snapshot) {
    if (this.props.templateId && previousProps.templateId !== this.props.templateId) {
      this.fetchTemplateSets();
    }
  }

  fetchTemplateSets() {
    this.setState({
      sets: [],
      currentSet: null,
      siblingSet: null,
      isCurrentSetLoading: true
    });

    designService.getTemplateSets(this.props.templateId).then(resp => {
      const current = resp.data.find(it => it.id === this.props.templateId) || {};
      const sibling = resp.data.find(it => it.id !== this.props.templateId) || {};

      this.setState({
        sets: resp.data.map(it => new designDomain.Design(it, util.sizes)),
        currentSet: new designDomain.Design(current, util.sizes),
        siblingSet: new designDomain.Design(sibling, util.sizes),
        isCurrentSetLoading: false
      });
    }).catch(() => {
      this.setState({ isCurrentSetLoading: true });
    });
  }

  selectCollection(collection) {
    store.dispatch(actions.setTemplateView('details'));
    store.dispatch(actions.setSelectedCollection(collection.title));

    this.setState({
      page: 0,
      searchBy: collection.term,
      isSearching: true,
    });

    this.fetchTemplates(collection.term, this.props.selectedFamily || '');
    $('#delete-icon').show();
  }

  selectFamily(family) {
    store.dispatch(actions.setTemplateView('group'));
    store.dispatch(actions.setSelectedFamily(family));
    store.dispatch(actions.setSelectedCollection(''));

    this.setState({
      page: 0,
      searchBy: '',
      isSearching: true,
    });

    this.fetchTemplates(null, family);
  }

  selectCategory(category) {
    store.dispatch(actions.setTemplateView('details'));
    store.dispatch(actions.setSelectedFamily(''));
    store.dispatch(actions.setSelectedCategory(category));

    this.setState({
      page: 0,
      searchBy: '',
      isSearching: true,
      category
    });

    this.fetchTemplates('', '', category.id);
    $('#delete-icon').show();
  }

  clearFilters() {
    store.dispatch(actions.setTemplateView('families'));
    store.dispatch(actions.setSelectedFamily(''));
    store.dispatch(actions.setSelectedCollection(''));
    store.dispatch(actions.setSelectedCategory(''));

    this.setState({
      page: 0,
      searchBy: '',
      isSearching: false,
      category: '',
    });

    if (this.props.templateFamilies.length == 0) {
      store.dispatch(actions.setTemplateFamilies([], true));

      designService.getTemplatesGroupedByFamily().then((response) => {
        store.dispatch(actions.setTemplateFamilies(response.data, false));
      }).catch(() => {
        store.dispatch(actions.setTemplateFamilies([], false));
      })
    }
  }

  updateTemplate(toUseDesign) {
    this.setState({ templateLoading: toUseDesign.id });
    designService.quickUpdateDesignTemplate(this.props.designId, toUseDesign.id, this.props.locationId).then(resp => {
      const design = new designDomain.Design(resp.data);

      initDesignInStore(design)
      renderDesign(design, { isMobile: store.getState().isMobileVersion });

      util.nextTick(() => {
        menuObject.fixDefaultIconColor();
      })

      store.dispatch(actions.setWebsiteToken(""));
      window.data.design.qrCodeId = "";

      cleanUpSEOFields();

      if (window.history) {
        window.history.replaceState({}, '', `${constants.appPrefix}/design?id=${design.id}`);
      }

      this.setState({ templateLoading: '' });

      if (store.getState().isMobileVersion) {
        store.dispatch(actions.setIsMobileAside(false));
      }
    }).catch((err) => {
      this.setState({
        templateLoading: ''
      })
    });
  }

  cleanUpSEOFields() {
    store.dispatch(actions.setShareLink(null));
    store.dispatch(actions.updateElementAttribute('seoRestaurantName', ''));
    store.dispatch(actions.updateElementAttribute('seoMenuAdjective', ''));
    store.dispatch(actions.updateElementAttribute('seoFoodType', ''));
    store.dispatch(actions.updateElementAttribute('seoCity', ''));
    store.dispatch(actions.updateElementAttribute('seoState', ''));
    store.dispatch(actions.updateElementAttribute('seoShareLinkError', ''));
    store.dispatch(actions.updateElementAttribute('seoExampleTitle', ''));
    store.dispatch(actions.updateElementAttribute('seoExampleText', ''));
  }

  handleSelectSize(size) {
    this.setState({ selectedSize: size, searchBy: $('.search-templates').val() });
    this.closeSizesFilterDropdown();
  };

  handleColorClick(color) {
    let filtered = this.state.selectedColors

    if (this.state.selectedColors.includes(color)) {
      filtered = filtered.filter(c => c !== color)
    } else {
      filtered.push(color)
    }

    this.setState({ selectedColors: filtered, searchBy: $('.search-templates').val() });
  }

  clearSizeAndColorFilters() {
    this.setState({ selectedColors: [], selectedSize: '', numberOfAppliedFilters: 0 });
    // this.fetchTemplates(this.state.searchBy, this.props.selectedFamily || '', true);
    this.clearFilters();
    util.hideDropdown();
  }

  applySizeAndColorFilters() {
    store.dispatch(actions.setSelectedFamily(util.getSizeLabel(this.state.selectedSize)));
    store.dispatch(actions.setSelectedCollection(''));
    // store.dispatch(actions.setTemplateView(''));
    store.dispatch(actions.setTemplateView('details'));
    // this.setState({ isSetsView: true, isSearchView: false, searchBy: $('.search-templates').val() });
    this.setState({ searchBy: $('.search-templates').val() });

    this.fetchTemplates(this.state.searchBy, '');
    util.hideDropdown();

    let numberOfFilters = 0;
    if (this.state.selectedSize) numberOfFilters++;
    numberOfFilters += this.state.selectedColors.length;

    this.setState({ numberOfAppliedFilters: numberOfFilters });
  }

  clearSelectedSize() {
    this.setState({ selectedSize: '' });
  }

  closeSizesFilterDropdown() {
    $(".sizes-filter > .dropdown-menu").removeClass('show');
  }

  handleCategoryClick(category) {
    this.setState({ suggestedCategories: [] });
    this.selectCategory(category);

    // this.selectCollection({ term: category.toLowerCase().replace('\'', ''), title: category })
    // this.fetchTemplates(category.toLowerCase().replace('\'', ''), '');
  }

  getTemplateSizeCount(size) {
    const found = this.state.templatesCountBySize.find(c => c.size === size);
    return found ? found.count : '';
  }

  render(props, state) {
    const view = props.templateView;
    let content = null;
    let groups = null;

    const sizesToExlude = [
      'custom', 'letter-landscape', 'legal-landscape', 'tabloid-landscape', 'a4-landscape',
      'biz-card-circular', 'legal', 'tabloid', 'menu-a4', 'kids-menu-legal-portrait',
      'kids-menu-tabloid-portrait', 'kids-menu-a4-portrait', 'kids-menu-tabloid-landscape',
      'kids-menu-a4-landscape', 'takeout-tabloid-trifold', 'folded-menu-letter-trifold', 'half-page-menu-long',
      'half-page-menu-wide', 'menu-a4-landscape'
    ]

    const sizes = util.sizes.filter(c => !sizesToExlude.includes(c.key)).map(size =>
      <div className={"size-option " + (size.key === state.selectedSize ? "selected" : "")} onClick={() => { this.handleSelectSize(size.key) }}>
        <label for={size.key}>
          {util.getSizeWithLabel(size.key)} <span className="option-dimensions">{util.getSize(size.key).dimensionsLabel}  <span className="option-count">({this.getTemplateSizeCount(size.key)})</span></span>
        </label>
      </div>
    )

    sizes.unshift(<div className={"size-option " + ("" === state.selectedSize ? "selected" : "")} onClick={() => { this.handleSelectSize("") }}>
      <label for={"size.key"}>
        Select Size
      </label>
    </div>)

    const selectedSizeLabel = state.selectedSize ? util.getSizeWithLabel(state.selectedSize) + " " + util.getSize(state.selectedSize).dimensionsLabel : '';

    const colors = [
      { color: "red", hex: "#F22532" },
      { color: "orange", hex: "#FC8643" },
      { color: "yellow", hex: "#FCCC23" },
      { color: "green", hex: "#78CB45" },
      { color: "blue", hex: "#1D64CE" },
      { color: "purple", hex: "#9747FF" },
      { color: "white", hex: "#FFFFFF" },
      { color: "black", hex: "#000000" },
      { color: "grey", hex: "#777777B3" },
      { color: "brown", hex: "#7A4722" },
      { color: "beige", hex: "#FCF2E3" }
    ];

    if (props.promoDesignsLoading) {
      content = (<Spinner />);
    } else if (!this.state.isSetsView) {
      if (view === 'families') {
        groups = props.templateFamilies.map(entry => {
          if (!!entry.family) {
            const family = (
              <div className={'collection'}>
                <h6>{entry.family}</h6>
                <a onClick={() => this.selectFamily(entry.family)}>See all &gt;</a>
              </div>
            );

            let count = 0;
            const designs = entry.designs.map(design => {
              count += 1;
              return count > 2 ? null : (
                <TemplateCard
                  design={design}
                  free={design.free}
                  isFreemium={props.isFreemium}
                  loading={state.templateLoading}
                  useTemplate={this.useTemplate}
                  showFavorite={true}
                  isFavorite={design.isFavorite}
                />
                // <div className={'design'}>
                //   <div className="inner">
                //     <div className="img-wrap">
                //       <FreeProFlag free={design.free} isFreemium={props.isFreemium} />
                //       <img loading={"lazy"} alt="thumbnail" onClick={() => this.useTemplate(design)} src={design.defaultThumbnailPath} />
                //       {state.templateLoading === design.id && <div className="template-spinner">
                //         <Spinner />
                //       </div>}
                //     </div>
                //   </div>
                // </div>
              )
            });

            return (
              <div className={'group'}>
                {family}
                <div className={'list'}>
                  {designs}
                </div>
              </div>
            );
          }
        });
      } else if (view === 'group') {
        groups = props.templateGroups.map(entry => {
          if (!!entry.collection) {
            const collection = (
              <div className={'collection'}>
                <h6>{entry.collection.title}</h6>
                <a onClick={() => this.selectCollection(entry.collection)}>See all &gt;</a>
              </div>
            );

            let count = 0;
            const designs = entry.designs.map(design => {
              count += 1;
              return count > 2 ? null : (
                <TemplateCard
                  design={design}
                  free={design.free}
                  isFreemium={props.isFreemium}
                  loading={state.templateLoading}
                  useTemplate={this.useTemplate}
                  showFavorite={true}
                  isFavorite={design.isFavorite}
                />
                // <div className={'design'}>
                //   <div className="inner">
                //     <div className="img-wrap">
                //     <FreeProFlag free={design.free} isFreemium={props.isFreemium} />
                //     <img loading={"lazy"} alt="thumbnail" onClick={() => this.useTemplate(design)} src={design.defaultThumbnailPath} />
                //     {state.templateLoading === design.id && <div className="template-spinner">
                //       <Spinner />
                //     </div>}
                //   </div>
                // </div>
                // </div>
              )
            });

            return (
              <div className={'group'}>
                {collection}
                <div className={'list'}>
                  {designs}
                </div>
              </div>
            );
          }
        });
      }

      if (view !== 'families' && !store.getState().promoDesignsLoading) {
        const all = props.templateGroups ? props.templateGroups.filter(it => !it.collection)[0] : [];
        if (!all || all.designs.length === 0) {
          content = (<p style="margin-left: 1rem;">No matches found.</p>);
        } else {
          content = all.designs.map(design => {
            return (
              <TemplateCard
                design={design}
                free={design.free}
                isFreemium={props.isFreemium}
                loading={state.templateLoading}
                useTemplate={this.useTemplate}
                name={design.name}
                showFavorite={true}
                isFavorite={design.isFavorite}
              />

              // <div className={'design ' + (design.isVisible ? '' : 'hidden')}>
              //   <div className="inner">
              //     <div className="img-wrap">
              //       <FreeProFlag free={design.free} isFreemium={props.isFreemium} />
              //       <img loading={"lazy"} onClick={() => this.useTemplate(design)} src={design.defaultThumbnailPath} alt={'thumbnail'} />
              //       {state.templateLoading === design.id && <div className="template-spinner">
              //         <Spinner />
              //       </div>}
              //       <FavoriteButton assetId={design.id} type="template" />
              //     </div>
              //     <h5>{design.name}</h5>
              //   </div>
              // </div>
            );
          });
          content = (
            <div>
              <h6 style="margin: .25rem 1rem; text-transform: capitalize; font-size: 13px;"
                className={state.searchBy.length > 0 ? 'hidden' : ''}>All results</h6>
              <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}> {content}</Masonry>
            </div>
          );
        }
      }
    }

    return (
      <div id="app-aside-text" className="aside-text aside-templates">
        {!state.isSetsView &&
          <header>
            <div className="breadcrumbs">
              <span className="slide-in-left"><label onClick={() => this.clearFilters()}>All templates</label></span>
              {props.selectedFamily ? <span className="slide-in-left">&gt;<label onClick={() => this.selectFamily(props.selectedFamily)}>{props.selectedFamily}</label></span> : ''}
              {props.selectedCategory ? <span className="slide-in-left">&gt;<label onClick={() => this.selectCategory(props.selectedCategory)}>{props.selectedCategory.name}</label></span> : ''}
              {props.selectedCollection ? <span className="slide-in-left">&gt;<label>{props.selectedCollection}</label></span> : ''}
            </div>

            <div className="input-search-templates">
              <input type="text" className="search-templates" placeholder={"Search " + (props.selectedFamily ? props.selectedFamily + " " : "25,000 ") + "templates"} value={state.searchBy}
                onKeyUp={
                  (ev) => {
                    this.onChangeSearchField.bind(ev);
                    if (ev.key === 'Enter') {
                      var onChangeField = this.onChangeSearchField.bind(ev);
                      onChangeField(ev);
                    }
                  }
                }
                onClick={(ev) => this.setState({ searchBy: ev.target?.value })}
                onChange={(ev) => { this.filterSuggestedCategories(ev.target.value); ev.target.value !== '' ? $('#delete-icon').show() : $('#delete-icon').hide() }} />
              {this.state.suggestedCategories.length > 0 ?
                <div className='suggested-categories'>
                  <ul className="category-list">
                    {this.state.suggestedCategories.map((category, index) => (
                      <li key={index} onClick={() => this.handleCategoryClick(category)}>
                        {category.name}
                      </li>
                    ))}
                  </ul>
                </div> : ''}

              <div className="dropdown">
                {state.numberOfAppliedFilters > 0 ? <span className="filter-badge">{state.numberOfAppliedFilters}</span> : ""}

                <svg id="filter-icon" className="icon icon-filter dropdown-toggle">
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-filter"} />
                </svg>

                <div className="dropdown-menu dropdown-sticky search-templates-filters" data-close="no">
                  <h3>Size</h3>
                  <div className="dropdown sizes-filter">
                    <input placeholder="Select Size" data-is-nested="true" readonly className="dropdown-toggle" value={selectedSizeLabel} />
                    <div className="dropdown-menu dropdown-sticky" data-close="no">
                      {sizes}
                      {/* <div className="sizes-filter-footer">
                        <div className="btn" onClick={() => { this.clearSelectedSize() }}>
                          Clear
                        </div>

                        <div className="btn primary" onClick={() => { this.closeSizesFilterDropdown() }}>
                          Done
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <h3>Color</h3>
                  <div className="colors-filter">
                    {colors.map((color) => (
                      <div className={"color-filter " + (state.selectedColors.includes(color.color) ? "selected" : "")} onClick={() => this.handleColorClick(color.color)}>
                        <div className={(state.selectedColors.includes(color.color) ? "selected" : "")} style={"background-color: " + color.hex + ";"}>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="templates-filters-footer">
                    <div className="btn" onClick={() => { this.clearSizeAndColorFilters() }}>
                      Clear {state.numberOfAppliedFilters > 0 ? <span>({state.numberOfAppliedFilters})</span> : ""}
                    </div>

                    <div className="btn primary" onClick={() => { this.applySizeAndColorFilters() }}>
                      Apply
                    </div>
                  </div>
                </div>
              </div>

              <svg id="delete-icon" onClick={this.onClickDeleteInputSearch.bind()} className="icon icon-delete-close">
                <use xlinkHref="#app-icon-delete-close" />
              </svg>
            </div>
          </header>}

        <div className={`scroller ${state.isSetsView ? 'no-top' : ''}`} style="top: 140px;" onScroll={this.infiniteLoadTemplates}>
          <div className="designs">

            {/* {!state.isSetsView && !props.isTemplate && !state.currentSet && !props.promoDesignsLoading && state.isCurrentSetLoading &&
              <Spinner />} */}

            {!state.isSetsView && !props.isTemplate && !state.isSearchView && state.currentSet && view === 'group' && props.selectedFamily == util.getSizeLabel(props.designSize) &&
              <div className={'group'}>
                <div className={'collection'}>
                  <h6>Current Template</h6>
                  {state.sets && state.sets.length > 1 &&
                    <a onClick={this.toggleSetsView.bind(this)}>See design collection &gt;</a>}
                </div>
                <div>
                  <TemplateCard
                    design={state.currentSet}
                    isFreemium={props.isFreemium}
                    free={state.currentSet.free}
                    loading={state.templateLoading}
                    useTemplate={this.useTemplate}
                    showFavorite={true}
                    isFavorite={state.currentSet.isFavorite}
                    name={state.currentSet.name}
                  />
                  {/* <div className={'design'}>
                    <div className="inner">
                      <div className="img-wrap">
                        <FreeProFlag free={state.currentSet.free} isFreemium={props.isFreemium} />
                        <img loading={"lazy"} onClick={() => this.useTemplate(state.currentSet)}
                          src={state.currentSet.defaultThumbnailPath} alt={'thumbnail'} />
                        {state.templateLoading === props.templateId && <div className="template-spinner">
                          <Spinner />
                        </div>}
                      </div>
                      <h5>{state.currentSet.name}</h5>
                    </div>
                  </div> */}

                  {state.sets && state.sets.length > 1 &&
                    <TemplateCard
                      design={state.siblingSet}
                      free={state.siblingSet.free}
                      isFreemium={props.isFreemium}
                      loading={state.templateLoading}
                      useTemplate={this.useTemplate}
                      name={state.siblingSet.name}
                      showFavorite={true}
                      isFavorite={state.siblingSet.isFavorite}
                    />
                    // <div className={'design'}>
                    //   <div className="inner">
                    //     <div className="img-wrap">
                    //       <FreeProFlag free={state.siblingSet.free} isFreemium={props.isFreemium} />
                    //       <img loading={"lazy"} onClick={() => this.useTemplate(state.siblingSet)}
                    //         src={state.siblingSet.defaultThumbnailPath} alt={'thumbnail'} />
                    //       {state.templateLoading === state.siblingSet.id && <div className="template-spinner">
                    //         <Spinner />
                    //       </div>}
                    //     </div>
                    //     <h5>{state.siblingSet.name}</h5>
                    //   </div>
                    // </div>
                  }
                </div>
              </div>
            }

            {state.isSetsView &&
              <div>
                <header style={'padding: 5px 15px; text-align: left;'}>
                  <a onClick={this.toggleSetsView.bind(this)}
                    style={'color: #444; font-size: 24px; font-weight: bold; cursor: pointer;'}>
                    <svg style={{ width: '15px', height: '15px' }}>
                      <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-arrow"} />
                    </svg>
                  </a>
                </header>
                <div>
                  <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                    {state.sets.map(design =>
                      <TemplateCard
                        design={design}
                        free={design.free}
                        isFreemium={props.isFreemium}
                        loading={state.templateLoading}
                        useTemplate={this.useTemplate}
                        name={design.name}
                        showFavorite={true}
                        isFavorite={design.isFavorite}
                      />
                      // <div className={'design'}>
                      //   <div className="inner">
                      //     <div className="img-wrap">
                      //       <FreeProFlag free={design.free} isFreemium={props.isFreemium} />
                      //       <img loading={"lazy"} onClick={() => this.useTemplate(design)} src={design.defaultThumbnailPath}
                      //         alt={'thumbnail'} />
                      //       {state.templateLoading === design.id && <div className="template-spinner">
                      //         <Spinner />
                      //       </div>}
                      //     </div>
                      //     <h5>{design.name}</h5>
                      //   </div>
                      // </div>
                    )}
                  </Masonry>
                </div>
              </div>}

            {!state.isSetsView && <div className={'groups'}>{groups}</div>}
            {!state.isSetsView && content}
          </div>
        </div>

        <UseTemplateModal
          designId={props.designId}
          hasChanges={props.hasChanges}
          design={state.useDesign}
          open={state.useDesignModal}
          setShowExitWarning={props.setShowExitWarning}
          onModalClose={() => this.setState({ useDesignModal: false })} />
      </div>
    )
  }
}
